import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useRef, useContext } from "react";
import Control from "ol/control/Control";
import { MapContext } from "../MapProvider";
const CustomControl = (props) => {
    const { control, controlContent, controlPosition, controlContentPosition, showContent = false, } = props;
    const map = useContext(MapContext);
    const controlRef = useRef(null);
    const controlContentRef = useRef(null);
    useEffect(() => {
        //control
        if (!(map && controlRef && controlRef.current))
            return;
        const options = {
            element: controlRef.current,
        };
        const control = new Control(options);
        map.addControl(control);
        return () => {
            map.removeControl(control);
        };
    }, [map]);
    useEffect(() => {
        //control content
        if (!(map && controlContent && controlContentRef && controlContentRef.current))
            return;
        const contentOptions = {
            element: controlContentRef.current,
        };
        const contentControl = new Control(contentOptions);
        map.addControl(contentControl);
        return () => {
            controlContent && map.removeControl(contentControl);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [map]);
    return (_jsxs(_Fragment, { children: [_jsx("div", { ref: controlRef, style: { position: "absolute", ...controlPosition }, children: control }), controlContent && (_jsx("div", { ref: controlContentRef, className: "map-custom-control-content", style: { position: "absolute", ...controlContentPosition }, children: showContent && controlContent }))] }));
};
export default CustomControl;
